module.exports = __webpack_public_path__ + "e3ae1b295eba5c4dd7df117aa159214a.svg";